(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ExchangerateDialogController', ExchangerateDialogController);

    ExchangerateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Exchangerate'];

    function ExchangerateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Exchangerate) {
        var vm = this;

        vm.exchangerate = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.exchangerate.id !== null) {
                Exchangerate.update(vm.exchangerate, onSaveSuccess, onSaveError);
            } else {
                Exchangerate.save(vm.exchangerate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:exchangerateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.pubDate = false;
        vm.datePickerOpenStatus.lastEdited = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
